{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Värimuokkain",
  "twoDimensionalSlider": "2D-liukusäädin"
}
